var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-value"},[(!_vm.isEmpty)?_c('span',{style:({ color: _vm.color })},[_c('span',[_vm._v(_vm._s(_vm.text))]),(_vm.unit)?_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.unit))]):_vm._e()]):_c('span',[_vm._v("--")])])}
var staticRenderFns = []

export { render, staticRenderFns }